//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------
//  -- Create interaction -------------
export const createWhatsNew = (returnedPayload) => ({ type: ActionTypes.whats_new.create_whats_new, payload: returnedPayload });
export const updateWhatsNew = (returnedPayload) => ({ type: ActionTypes.whats_new.update_whats_new, payload: returnedPayload });
export const deleteWhatsNew = (returnedPayload) => ({ type: ActionTypes.whats_new.delete_whats_new, payload: returnedPayload });
export const listWhatsNew = (returnedPayload) => ({ type: ActionTypes.whats_new.list_whats_new, payload: returnedPayload });
